export const SN_ATTRIBUTE = 'attribute'
export const ATTRIBUTE_UPD_ATTRIBUTES = SN_ATTRIBUTE + '/UPD_ATTRIBUTES'
export const ATTRIBUTE_UPD_BLACKLIST = SN_ATTRIBUTE + '/UPD_BLACKLIST_ATTRIBUTES'
export const ATTRIBUTE_SET_PRELOADED = SN_ATTRIBUTE + '/SET_PRELOADED'
export const ATTRIBUTE_SET_FULL = SN_ATTRIBUTE + '/SET_FULL'
